<ng-container>
    <div *ngIf="isMapToogleButtonVisible">
        <mat-button-toggle-group [(ngModel)]="isDefaultMap" name="maptype" aria-label="Map type">
            <mat-button-toggle [value]="true">Default map</mat-button-toggle>
            <mat-button-toggle [value]="false">1200 aero map</mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <mat-drawer-container autosize>
        <mat-drawer-content>
            <div style="height: 99%;">
                <div class="drawer-button" (click)="toggleSettingsDrawer()" *ngIf="isDefaultMap">
                    <button class="mat-dark-blue" mat-flat-button>
                        <mat-icon *ngIf="!isDrawerOpen"
                            >chevron_left</mat-icon
                        >
                        <mat-icon *ngIf="isDrawerOpen"
                            >chevron_right</mat-icon
                        >
                    </button>
                </div>
                <ng-container *ngIf="isDefaultMap">
                    <div class="aircraft-legend" *ngIf="showLegend">
                        <app-aircraft-legend></app-aircraft-legend>
                    </div>
                    <div [ngClass]="{
                        'lobby': isLobbyView,
                        'default': !isLobbyView
                    }" class="flight-watch-container">
                        <app-flight-watch-map-wrapper
                            id="map-wrapper"
                            #map
                            (setIcaoList)="setIcaoList($event)"
                            (textFilterChanged)="onTextFilterChanged($event)"
                            (showCommercialAircraftFilter)="filterCommercialAircrafts($event)"
                            (icaoChanged)="updateIcao($event)"
                            (aicraftClick)="onAircraftClick($event)"
                            (popUpClosed)="onPopUpClosed($event)"
                            style="width: 100%"
                            [center]="center"
                            [data]="flightWatchData"
                            [isStable]="isStable"
                            [icaoList]="airportsICAO"
                            [icao]="selectedICAO"
                            [showFilters]="showFilters"
                        ></app-flight-watch-map-wrapper>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isDefaultMap">
                    <app-twelve-hundred-aero-map 
                        #twelveHundredAeroMap
                        [fboId]="fboId"
                        [icao]="selectedICAO"
                        [groupId]="groupId"
                        [flightWatchData]="flightWatchData"
                    ></app-twelve-hundred-aero-map>
                </ng-container>
            </div>
        </mat-drawer-content>

        <mat-drawer
            mode="side"
            #mapfilters
            position="end"
            class="drawer-container"
        >
            <ng-container *ngIf="isDefaultMap">
                <app-flight-watch-aicraft-grid
                    #flightwatchAircraftGrid
                    [data]="filteredFlightWatchData"
                    [icaoList]="airportsICAO"
                    [icao]="selectedICAO"
                    [filteredTypes]="this.currentFilters.filteredTypes"
                    (textFilterChanged)="onTextFilterChanged($event)"
                    (typesFilterChanged)="onTypesFilterChanged($event)"
                    (icaoChanged)="updateIcao($event)"
                    (updateDrawerButtonPosition)="updateButtonOnDrawerResize()"
                    [showFilters]="showFilters"
                    [isLobbyView]="isLobbyView"
                ></app-flight-watch-aicraft-grid>
            </ng-container>
        </mat-drawer>
    </mat-drawer-container>
</ng-container>
<ngx-ui-loader
[loaderId]="chartName"
bgsColor="rgb(100, 181, 246)"
bgsPosition="center-center"
bgsType="ball-spin"
overlayColor="rgba(0, 0, 0, 0.1)"
></ngx-ui-loader>
